import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import OnboardingProgressBar from "./OnboardingProgressBar";
import OnboardingWrapper from "../components/OnboardingWrapper";
import ChatWidgetModal from "../components/ChatWidgetModal";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import PrimaryLinkButton from "../components/PrimaryLinkButton";
import useWindowSize from "../hooks/useWindowSize";
import ChatWidget from "../components/ChatWidget";
import ChatButton from "../icons/ChatButton";
import { useCompanyApi } from "../hooks/useCompanyApi";

const OnboardingTestAgent = () => {
  const { updateCompany } = useCompanyApi();
  const windowSize = useWindowSize();
  const [chatTestCompleted, setChatTestCompleted] = useState(
    windowSize?.width > 640
  );
  const [showWidgetModal, setShowWidgetModal] = useState(false);

  const navigate = useNavigate();

  const onSubmit = async e => {
    e.preventDefault();
    await updateCompany({
      registration_step: "subscription",
    });
    navigate("/onboarding/subscription");
  };

  const onSkip = async () => {
    await updateCompany({
      registration_step: "subscription",
    });
    navigate("/onboarding/subscription");
  };

  const disabled = !chatTestCompleted;

  const onCloseWidgetModal = () => {
    setShowWidgetModal(false);
    setChatTestCompleted(true);
  };

  return (
    <OnboardingWrapper
      onSubmit={onSubmit}
      actions={
        <>
          <div className="pb-20 justify-center w-full hidden sm:flex">
            <OnboardingProgressBar currentStep={3} />
          </div>

          <div className="sm:hidden w-full flex flex-col gap-4 relative items-center">
            <button
              type="button"
              className="absolute -top-24 right-0"
              onClick={() => setShowWidgetModal(true)}
            >
              <ChatButton />
            </button>

            {!chatTestCompleted ? (
              <SecondaryButton>Continue</SecondaryButton>
            ) : (
              <PrimaryButton>Continue</PrimaryButton>
            )}

            <PrimaryLinkButton onClick={onSkip} type="button">
              Skip this step
            </PrimaryLinkButton>
          </div>
        </>
      }
    >
      <div className="sm:max-w-7xl w-full flex flex-col gap-6 mt-8 px-4 sm:px-0 mb-6 sm:mb-0">
        <div>
          <h1 className="text-3xl font-semibold leading-9 text-gray-900 text-center">
            Test your agent
          </h1>
          <p className="text-base font-normal leading-normal text-center text-slate-600">
            Based on the information you uploaded, try asking your AI agent
            questions your customers would normally ask.
          </p>
        </div>

        {windowSize?.width > 640 && (
          <ChatWidget
            onSendMessage={() => setChatTestCompleted(true)}
            test
            showHeading={false}
          />
        )}

        <div className="hidden sm:block max-w-sm m-auto w-full">
          <PrimaryButton disabled={disabled}>Continue</PrimaryButton>
        </div>

        <div className="hidden sm:flex justify-center">
          <PrimaryLinkButton onClick={onSkip} type="button">
            Skip this step
          </PrimaryLinkButton>
        </div>

        <div className="sm:hidden">
          {chatTestCompleted ? (
            <SecondaryButton
              onClick={() => setShowWidgetModal(true)}
              type="button"
            >
              Open the chat
            </SecondaryButton>
          ) : (
            <PrimaryButton
              onClick={() => setShowWidgetModal(true)}
              type="button"
            >
              Open the chat
            </PrimaryButton>
          )}
        </div>
      </div>

      {windowSize?.width <= 640 && (
        <ChatWidgetModal
          open={showWidgetModal}
          onClose={onCloseWidgetModal}
          test
        />
      )}
    </OnboardingWrapper>
  );
};

export default OnboardingTestAgent;
